import { create } from 'zustand';
import { DEFAULT_SETTINGS, type Settings } from '@gonka-wallet/storage';

interface SettingsState extends Settings {
  setPartial: (patch: Partial<Settings>) => void;
  setAll: (settings: Settings) => void;
}

export const useSettingsStore = create<SettingsState>((set) => ({
  ...DEFAULT_SETTINGS,
  setPartial: (patch) => set((state) => ({ ...state, ...patch })),
  setAll: (settings) => set(settings),
}));
